import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=56735690&"
import script from "./footer.vue?vue&type=script&lang=ts&"
export * from "./footer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports